import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
};

const EmpListSlice = createSlice({
    name: 'employeelist',
    initialState,
    reducers: {
        dataRequest: (state) => {
            state.status = 'loading';
        },
        dataSuccess: (state, action) => {
            state.status = 'succeeded';
            state.data = action.payload;
        },
        dataFailure: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
    },
});

export const selectEmployeelist = (state) => state.employeelist;
export const { dataRequest, dataSuccess, dataFailure } = EmpListSlice.actions;
export default EmpListSlice.reducer;
